import * as React from "react";
import { Link } from "react-router-dom";
import { HorseLink } from "../common/HorseLink";
import { HorseForSale, HorseForSaleStateFriendlyName } from "src/model/HorseForSale";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkSquareAlt } from "@fortawesome/free-solid-svg-icons";
import { HorseForSaleLink } from "../common/HorseForSaleLink";

export const CheckoutHorseHeader = ({
    currentHorseForSale,
    stepNumber,
    stepTitle
}: {
    currentHorseForSale: HorseForSale;
    stepNumber: number;
    stepTitle: string;
}) => {
    return (
        <div className="row mx-0">
            <div className="col-3 px-0">
                Step {stepNumber} of 5 - {stepTitle}
            </div>
            <div className="col-3 px-0 text-center d-flex">
                Horse: &nbsp;
                {/* <HorseLink horse={currentHorseForSale.horse} className="ml-2" targetBlank={true}/></div> */}
                <Link to={`/horse/${currentHorseForSale.horse.id}/`} className="d-flex flex-nowrap" target="_blank">
                    <div className="" style={{ whiteSpace: "nowrap" }}>
                        {currentHorseForSale.horse.name}
                    </div>
                    <FontAwesomeIcon icon={faExternalLinkSquareAlt} className="ml-2 mt-1" />
                </Link>
            </div>
            <div className="col-3 px-0 text-center">State: {HorseForSaleStateFriendlyName(currentHorseForSale.state)}</div>
            <div className="col-3 px-0 text-right d-flex">
                <div className="ml-auto">Bid Amount:&nbsp;</div>
                <Link to={`/horses-for-sale/${currentHorseForSale.id}/acknowledgement`} className="d-flex flex-nowrap" target="_blank">
                    <div className="" style={{ whiteSpace: "nowrap" }}>
                        {(currentHorseForSale.price! / 100).toLocaleString("en-CA", { style: "currency", currency: "CAD" })}
                    </div>
                    <FontAwesomeIcon icon={faExternalLinkSquareAlt} className="ml-2 mt-1" />
                </Link>
            </div>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/checkout/CheckoutHorsesHeader.tsx